import type SVGType from 'types/svg.types';

const EuroCircleIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1985 14.2295L14.4538 15.0504M17.9449 13.767C17.7138 13.0255 17.2325 12.4435 16.5563 12.1974C15.207 11.7063 13.5925 12.7386 12.9503 14.5031C12.308 16.2677 12.8813 18.0962 14.2306 18.5873C14.9068 18.8335 15.6496 18.697 16.3032 18.2775M22.3472 17.9233C20.9494 21.7638 16.703 23.7439 12.8625 22.3461C9.02209 20.9483 7.04195 16.7019 8.43975 12.8614C9.83756 9.021 14.084 7.04086 17.9244 8.43866C21.7649 9.83647 23.745 14.0829 22.3472 17.9233Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);

export default EuroCircleIcon;
